import VueRouter from 'vue-router'


const routes = [
  {
    path: '/jianpan',
    name: 'JianPan',
    component: () => import('../views/formfill')
  },
  {
    path: '/select',
    name: 'select',
    component: () => import('../views/MuLu')
  },
  {
    path: '/bz_html',
    name: '申请报装',
    component: () => import('../baozhuangViews/bz_html.vue'),
    meta:{
      isAuth:true,
      title:'申请报装（网页版）',

    },
  },
  {
    path: '/bz_html_re',
    name: '报装申请结果',
    component: () => import('../baozhuangViews/bz_html_re.vue'),
    meta:{
      isAuth:true,
      title:'报装申请结果（网页版）',
    },
  },
  {
    path: '/bz_html_info',
    name: '报装申请记录',
    component: () => import('../baozhuangViews/bz_html_info.vue'),
    meta:{
      isAuth:true,
      title:'报装申请记录（网页版）',
    },
  },
  {
    path: '/dt_bz_home',
    name: '网上服务大厅',
    component: () => import('../baozhuangViews/home.vue'),
    meta:{
      isAuth:true,
      title:'网上服务大厅',
    },
  },
  {
    path: '/change',
    name: '用水信息变更',
    component: () => import('../baozhuangViews/change.vue'),
    meta:{
      isAuth:true,
      title:'用水信息变更',
    },
  },
  {
    path: '/change_info',
    name: '用水信息变更记录',
    component: () => import('../baozhuangViews/change_info.vue'),
    meta:{
      isAuth:true,
      title:'用水信息变更记录',
    },
  },
  {
    path: '/bx',
    name: '用水报修申请',
    component: () => import('../baozhuangViews/bx.vue'),
    meta:{
      isAuth:true,
      title:'用水报修申请',
    },
  },
  {
    path: '/bx_info',
    name: '用水报修申请记录',
    component: () => import('../baozhuangViews/bx_info.vue'),
    meta:{
      isAuth:true,
      title:'用水报修申请记录',
    },
  },
  {
    path: '/xh',
    name: '用水信息销户申请',
    component: () => import('../baozhuangViews/xh.vue'),
    meta:{
      isAuth:true,
      title:'用水信息销户申请',
    },
  },
  {
    path: '/xh_info',
    name: '用水信息销户申请记录',
    component: () => import('../baozhuangViews/xh_info.vue'),
    meta:{
      isAuth:true,
      title:'用水信息销户申请记录',
    },
  },
  {
    path: '/html_pay',
    name: '用水费用缴纳',
    component: () => import('../baozhuangViews/pay.vue'),
    meta:{
      isAuth:true,
      title:'用水费用缴纳',
    },
  },
  {
    path: '/read_text',
    name: 'reading',
    component: () => import('../baozhuangViews/test.vue'),
    meta:{
      isAuth:true,
      title:'reading',
    },
  },
  {
    path: '/bz_back',
    name: 'bz_back',
    component: () => import('../baozhuangViews/KuangJia.vue'),
    children: [
      {
        path: '',
        redirect: '/bz_back/home'  // 这里添加重定向
      },
      {
        path: '/bz_back/home',
        name: '首页',
        component: () => import('../views/wx_baozhuang/back/home.vue'),
        meta:{
          isAuth:true,
          title:'首页',
          keepAlive: true
        },
      },
      {
        path: '/bz_back/report_page',
        name: '报装申请',
        component: () => import('../views/wx_baozhuang/back/back.vue'),
        meta:{
          isAuth:true,
          title:'报装申请',
          keepAlive: true
        },
      },
      {
        path: '/bz_back/ysxz_change',
        name: '用水性质变更审批',
        component: () => import('../views/wx_baozhuang/back/ysxz_change.vue'),
        meta:{
          isAuth:true,
          title:'用水性质变更审批',
          keepAlive: true
        },
      },
      {
        path: '/bz_back/phone_change',
        name: '联系电话变更审批',
        component: () => import('../views/wx_baozhuang/back/phone_change.vue'),
        meta:{
          isAuth:true,
          title:'联系电话变更审批',
          keepAlive: true
        },
      },
      {
        path: '/bz_back/jths_change',
        name: '阶梯水价用户人口变更审批',
        component: () => import('../views/wx_baozhuang/back/jths_change.vue'),
        meta:{
          isAuth:true,
          title:'阶梯水价用户人口变更审批',
          keepAlive: true
        },
      },
      {
        path: '/bz_back/gmgh_change',
        name: '更名过户审批',
        component: () => import('../views/wx_baozhuang/back/gmgh_change.vue'),
        meta:{
          isAuth:true,
          title:'更名过户审批',
          keepAlive: true
        },
      },
      {
        path: '/bz_back/bx',
        name: '用水报修审批',
        component: () => import('../views/wx_baozhuang/back/bx_back.vue'),
        meta:{
          isAuth:true,
          title:'用水报修审批',
          keepAlive: true
        },
      },
      {
        path: '/bz_back/xh',
        name: '用水销户审批',
        component: () => import('../views/wx_baozhuang/back/xh_back.vue'),
        meta:{
          isAuth:true,
          title:'用水销户审批',
          keepAlive: true
        },
      },
      {
        path: '/bz_back/dingtaoqu',
        name: '定陶区工程建设项目审批',
        component: () => import('../baozhuangViews/dingtaoqu.vue'),
        meta:{
          isAuth:true,
          title:'定陶区工程建设项目审批',
          keepAlive: true
        },
      },
    ]
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/LoginRe/login.vue')
  },
  {
    path: '/',
    name:'reset',
    component:() => import('../views/Home/Home')
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('../views/LoginRe/Register.vue')
  },
  {
    path: '/404',
    name: '404',
    component: () => import('../views/404.vue')
  },
  {
    path: '/report_installation',
    name: '报装',
    component: () => import('../views/wx_baozhuang/report-installation')
  },
  {
    path: '/report_installation_records',
    name: '报装记录',
    component: () => import('../views/wx_baozhuang/report-installation-records')
  },
  {
    path: '/report_res',
    name: '报装申请结果',
    component: () => import('../views/wx_baozhuang/report-res')
  },
  {
    path: '/report_page',
    name: '报装后台',
    component: () => import('../views/wx_baozhuang/back/back.vue')
  },
  {
    path: '/',
    name: 'KuangJia',
    component: () => import('../views/KuangJia.vue'),
    children: [
      {
        path: '/home',
        name: '首页',
        component: () => import('../views/Home/Home'),
        meta:{
          isAuth:true,
          title:'首页',

        },
      },
      {
        path: '/usersale',
        name: '用户购买出库',
        component: () => import('../views/InOut/ChuKu/Cset/setChuKuOut'),
        meta:{
          isAuth:true,
          title:'用户购买出库',
          keepAlive: true
        },
      },
      {
        path: '/lingliao',
        name: '工程领料出库',
        // component: () => import('../views/InOut/ChuKu/Cset/setChuKuG'),
        component: () => import('../views/InOut/ChuKu/Cset/setChuKuOutG'),
        meta:{
          isAuth:true,
          title:'工程领料填报',
          keepAlive: true
        },
      },
      {
        path: '/yltjgc',
        name: '工程领料出库填报',
        component: () => import('../views/InOut/ChuKu/Cset/setChuKuG'),
        meta:{
          isAuth:true,
          title:'工程领料出库填报',
          keepAlive: true
        },
      },
      {
        path: '/yltjtb',
        name: '用户购买填报',
        component: () => import('../views/InOut/ChuKu/Cset/setChuKu'),
        meta:{
          isAuth:true,
          title:'用户购买填报',
        },
      },
      {
        path: '/ylfyjs',
        name: '用户费用结算',
        component: () => import('../views/InOut/ChuKu/Cset/setChuKuPay'),
        meta:{
          isAuth:true,
          title:'用户费用结算',
        },
      },
      {
        path: '/ylfyjsg',
        name: '工程费用结算',
        component: () => import('../views/InOut/ChuKu/Cset/setChuKuPayG.vue'),
        meta:{
          isAuth:true,
          title:'工程费用结算',
        },
      },
      {
        path: '/usersaleth',
        name: '用户购买单汇总',
        component: () => import('../views/InOut/ChuKu/CHuiZong/ChuKuUser.vue'),
        meta:{
          isAuth:true,
          title:'用户购买单汇总',
        },
      },{
        path: '/lingliaoth',
        name: '工程出库单汇总',
        component: () => import('../views/InOut/ChuKu/CHuiZong/ChuKuGS.vue'),
        meta:{
          isAuth:true,
          title:'工程出库单汇总',
        },
      },
      {
        path: '/usersalethx',
        name: '用户购买详情汇总',
        component: () => import('../views/InOut/ChuKu/CHuiZong/ChuKuU.vue'),
        meta:{
          isAuth:true,
          title:'用户购买详情汇总',
        },
      },{
        path: '/lingliaothx',
        name: '工程出库详情汇总',
        component: () => import('../views/InOut/ChuKu/CHuiZong/ChuKu.vue'),
        meta:{
          isAuth:true,
          title:'工程出库详情汇总',
        },
      },
      {
        path: '/paytuiku',
        name: '退库费用结算',
        component: () => import('../views/InOut/TuiKu/setTuiKu/payTuiKuU.vue'),
        meta:{
          isAuth:true,
          title:'退库费用结算',
        },
      },
      {
        path: '/gongchength',
        name: '工程退库（退库汇总）',
        component: () => import('../views/InOut/TuiKu/TuiKu/TuiKu'),
        meta:{
          isAuth:true,
          title:'公司退库汇总',
        },
      },
      {
        path: '/userth',
        name: '用户退货（退库汇总）',
        component: () => import('../views/InOut/TuiKu/TuiKu/TuiKuU'),
        meta:{
          isAuth:true,
          title:'用户退库汇总',
        },
      },
      {
        path: '/gongchengt',
        name: '公司退库填报',
        component: () => import('../views/InOut/TuiKu/setTuiKu/setTuiKu'),
        meta:{
          isAuth:true,
          title:'公司退库填报',
        },
      },
      {
        path: '/usert',
        name: '用户退库填报',
        component: () => import('../views/InOut/TuiKu/setTuiKu/setTuiKuU'),
        meta:{
          isAuth:true,
          title:'用户退库填报',
        },
      },
      {
        path: '/userSetting',
        name: '人员管理',
        component: () => import('../views/Base/UserSetting.vue'),
        meta:{
          isAuth:true,
          title:'人员管理',
        },
      },
      {
        path: 'cleibie',
        name: '类别信息',
        component: () => import('../views/CaiLiao/CLeiBie'),
        meta:{
          isAuth:true,
          title:'材料配置',
        },
      },
      {
        path: 'cxinxi',
        name: '材料信息',
        component: () => import('../views/CaiLiao/CXinXi'),
        meta:{
          isAuth:true,
          title:'库存信息',
        },
      },
       {
         path: 'ruku',
         name: '入库信息汇总',
         component: () => import('../views/InOut/RuKu/RuKu'),
         meta:{
           isAuth:true,
           title:'入库信息汇总',
         },
       },
       {
         path: 'newruku',
         name: '入库填报',
         component: () => import('../views/InOut/RuKu/setRuKu'),
         meta:{
           isAuth:true,
           title:'入库填报',
         },
       },
      {
         path: 'setruku',
         name: '材料入库',
         component: () => import('../views/InOut/RuKu/saveRuKu.vue'),
        meta:{
          isAuth:true,
          title:'材料入库',
        },
       },
      {
        path: 'baozhuang',
        name: '工程填报',
        component: () => import('../views/BaoZhuang/BaoZ'),
        meta:{
          isAuth:true,
          title:'工程填报',
        },
      },
      {
        path: 'shoufei',
        name: '工程收费',
        component: () => import('../views/BaoZhuang/ShouFei'),
        meta:{
          isAuth:true,
          title:'工程收费',
        },
      },
      ]
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// router.beforeEach((to,from,next) => {
//   localStorage.setItem("currentPathName",to.name)
//   next()
// })
router.beforeEach((to, from, next) => {
  localStorage.setItem("currentPathName",to.name)
  if (to.path === from.path) {
    next(false); // 取消导航
  } else {
    next(); // 完成导航
  }
});
// router.onError((error) => {
//   console.error(error)
//   const pattern = /Loading chunk/g
//   const isChunkLoadFailed = error.message.match(pattern)
//   const targetPath = $router.history.pending.fullPath
//   if (isChunkLoadFailed && error.type === 'missing') {
//     $router.push(targetPath)
//   }
// })


export default router
